import React from "react";

/**
 * The Production Agent Workspace *body*: the center workspace beside the
 * right context region.
 *
 * HISTORY OF THIS COMPONENT, BECAUSE ITS SLOTS CHANGED MEANING
 * ------------------------------------------------------------
 * AW-2A introduced this as the whole Production body, with slots named
 * `status` and `panels` -- a status/control rail beside a panel region,
 * because those were the only two regions that existed. PR-A restores
 * the intended four-region workspace
 * (WORKSPACE-FEATURE-001 S5.1): the status/control rail became the
 * header region and moved out of the body entirely, and the panel
 * region became the center workspace with its own tab model.
 *
 * So the slots are renamed to what they now hold. The `data-testid` is
 * deliberately NOT renamed: it is referenced by existing production
 * shell tests, and churning it would cost real assertions to prove
 * nothing.
 *
 * WHY NOT `WorkspaceGrid`
 * ----------------------
 * Unchanged from AW-2A, and still true. `WorkspaceGrid` hardcodes
 * `flex ... items-stretch` with no breakpoint, so its two slots sit side
 * by side at EVERY width, and its slots are named for the fixture
 * workspace's own semantics (Main Card beside the Agent Tools card).
 * This component is free to be responsive and names its own regions.
 *
 * LAYOUT
 * ------
 * Column below `lg`, row at `lg` and above. The center workspace takes
 * the remaining width; the context region is fixed-width beside it and
 * stacks beneath it on narrow viewports.
 *
 * Pure presentation -- React is its only import, it holds no state, and
 * it decides nothing about the dialer lifecycle.
 */
export default function WorkspaceProductionLayout({ center, context }) {
  return (
    <div
      className="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden lg:flex-row lg:items-stretch"
      data-testid="workspace-production-layout"
    >
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{center}</div>
      {context}
    </div>
  );
}
